import React, { useState } from 'react';

import firebase from '../firebase'
import { authenticate, isAutheticated, signup } from './Helper';
import { Link, Redirect, useHistory } from "react-router-dom";
import { getToken } from '../CloudFb';

import Alert from 'react-bootstrap/Alert'
import Base from './Base';


function Home() {
    const [values, setValues] = useState({
        name: "",
        last: "",
        email: "",
        password: "",
        error: "",
        success: false,
        didRedirect: false,
    });


    const { name, email, password, error, success, last, role, didRedirect } = values;

    const { displayName } = isAutheticated()

    const handleChange = (name) => (event) => {
        setValues({ ...values, error: false, [name]: event.target.value });
    };

    const signInWithGoogle = async (event) => {
        event.preventDefault();
        await firebase.googleLogin()
        let { displayName, email } = firebase.getCurrentUser()

        authenticate({ name: displayName, email }, () => {
            setValues({
                ...values,
                didRedirect: true,
            });
        });

        let password = '890098'
        signup({ name: displayName, email, password }).then((data) => {
            if (data.error) {
                setValues({ ...values, error: data.error, success: false });
            } else {


            }
        })
        //     .catch(console.log("Error in signup"));


        //let { displayName, email, } = firebase.getCurrentUser()



    }


    const performRedirect = () => {
        // if (didRedirect) {
        //     if (displayName) {
        //         return <Redirect to="/productDetail/cart" />
        //     } else {
        //         return <Redirect to="/" />
        //     }
        // }
        if (isAutheticated()) {
            return <Redirect to="/sub" />;
        }
    };


    const signUpForm = () => {
        return (
            <div className="row">
                <div className="col-md-6 offset-sm-3 text-left">
                    <div className="container">
                        <div className="box">
                            {/* <h3>SignUp Page</h3> */}
                            <br>

                            </br>
                            <div className="card">
                                <div className="card-body ">

                                    <div className="login-buttons text-center" >
                                        <button className="login-provider-button" onClick={signInWithGoogle}>
                                            <img src="https://developers.google.com/identity/images/g-logo.png" height="30" alt="google icon" />
                                            <span> Sign in with Google</span>

                                        </button>

                                    </div>

                                </div>


                            </div>

                        </div>
                    </div>
                </div>
            </div>
        );
    };
    return (
        <Base title="CoWin  Notifier" description="Get notified by Push Notification and email whenever slots open">
            <div className='bg-dark' >
                {/* <div className=" text-center">
                    <h1 className="text-success">CoWin slot notifier</h1><br></br>
                    <p className='text-white'>Get notified by email whenever slots open</p>
                </div> */}

                <h6 className="text-center text-danger">Note: Allow Notification Permission</h6>

                {signUpForm()}
                {performRedirect()}



                <div className="text-center container-fluid text-white">
                    <h3>We never book vaccine</h3>
                    <p>We just notify you whenever slot available</p>

                </div>


            </div>
        </Base>
    )
}

export default Home
//dns1.p08.nsone.net